<template>
  <div id="events" class="slideUp">
    <div class="close" @click="$closeModal()">
      <i class="anyteachicon anyteach-prev" />
      返回
    </div>
    <h1>选择场次 / 价格</h1>
    <div class="top">
      <div class="left" :style="$bgd(img)" />
      <div class="right">
        <h2>{{ type }}</h2>
        <h1>{{ title }}</h1>
      </div>
    </div>
    <!-- <h3 v-if="now">现在时间 {{ now.format("M月D日 HH:mm:ss") }}</h3> -->
    <div class="events">
      <Item
        v-for="event in events"
        :now="now"
        :id="event.id"
        :color="color"
        :title="event.event_title"
        :subtitle="event.event_subtitle"
        :detail="event.subtitle_detail"
        :start_time="event.start_time"
        :end_time="event.end_time"
        :key="event.id"
        :address="event.address"
        :price="event.price"
        :show_time="event.show_time"
        :shelf_time="event.shelf_time"
        :done="event.done"
        @pay="$emit('pay', { event, meta: $event })"
        :total="event.total"
        :is_countdown="event.is_countdown"
        :is_buy="event.is_buy"
        :is_limited="event.limited"
        :is_coupon="event.is_coupon"
        :is_first="event.is_first"
      />
    </div>
  </div>
</template>

<script>
import Item from "./Item"

export default {
  name: "Events",
  props: ["events", "type", "img", "title", "subtitle", "color"],
  components: { Item },
  data() {
    return {
      now: this.$moment(),
      nowInterval: null,
    }
  },
  created() {
    this.$disableScroll()
    this.nowInterval = setInterval(() => {
      this.now = this.$moment()
    }, 1000)
  },
  beforeDestroy() {
    this.$enableScroll()
    clearInterval(this.nowInterval)
  },
}
</script>

<style scoped lang="scss">
@import "../style.scss";

#events {
  height: 100%;
  background: white;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
  overflow: scroll !important;
  padding: 0 5%;
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;

  h1 {
    font-size: 25px;
  }
  .close {
    padding: 30px 0 10px 0;
    opacity: 0.5;
    display: block;
    font-size: 0.9rem;
  }
  .top {
    display: flex;
    padding: 15px 0 30px 0;
    align-items: center;
    display: none;
    .left {
      min-width: 168px;
      min-height: 110px;
      background-color: white;
      border-radius: 4px;
      border: $border;
    }
    @media only screen and (max-width: 320px) {
      .left {
        min-width: 136.8px;
        min-height: 90px;
      }
    }
    .right {
      padding: 0 0 0 15px;
      vertical-align: middle;
      display: flex;
      flex-direction: column;
      justify-content: center;
      h1 {
        @include avenir-demi();
        font-size: 25px;
        line-height: 1.2;
        margin-bottom: 0;
      }
      h2 {
        font-size: 13px;
        font-weight: 500;
        letter-spacing: 3.6px;
        margin: 0;
        opacity: 0.7;
      }
    }
  }

  .events {
    h1 {
      font-size: 13px;
      font-weight: 500;
      opacity: 0.5;
    }
  }
}
</style>
